import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { CONSULTAVENTAS_VER_DETALLES, CONSULTAVENTAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import VerDetallesPage from './verDetalles'

export default function VentasConsultaVentasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CONSULTAVENTAS_VER_DETALLES}/:id`} component={VerDetallesPage} />
        <Route path={`/${CONSULTAVENTAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
